<template>
    <div class="ml-5">
        <label for="show-percent-diff">
            <input @change="emitInput" :disabled="disabled" id="show-percent-diff" type="checkbox" name="show-percent-diff" v-model="value" class="mr-1" />
            Show Percent Difference
        </label>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps(['defaultValue', 'disabled']);

const emit = defineEmits(['update:modelValue']);

const value = ref(props.defaultValue);

function emitInput() {
    emit('update:modelValue', value.value);
}

watch(() => props.defaultValue, (newValue) => {
    value.value = newValue;
    emitInput();
});
</script>
